var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TTabs',{attrs:{"tabs":_vm.tabs,"activeTab":_vm.$route.query.tab},on:{"change-tab":function($event){return _vm.$router.push({ query: { tab: $event } })}},scopedSlots:_vm._u([{key:"supplier",fn:function(){return [_c('Supplier')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }